export enum AdminReturnWorkflowStatus {
  RESOLVED = "resolved",
  BLOCKED = "blocked",
  LOOKING = "looking",
}
